// app/src/App.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
   PartPage, PartSignupPage, ProPage, ProSignupPage,
  RedirectPage, PartLegacyResetPasswordPage, PartLegacyMigratePage
} from './pages';

function App() {
  return (<Routes>
      <Route path="/pro" element={<ProPage/>}/>
      <Route path="/pro/signup" element={<ProSignupPage/>}/>
      <Route path="/part" element={<PartPage/>}/>
      <Route path="/part/legacyResetPassword" element={<PartLegacyResetPasswordPage/>}/>
      <Route path="/part/legacyMigrate" element={<PartLegacyMigratePage/>}/>
      <Route path="/part/signup" element={<PartSignupPage/>}/>
      <Route path="/redirect" element={<RedirectPage/>}/>
      <Route path="*" element={<Navigate to="/pro" replace/>}/>
    </Routes>);
}

export default App;
